import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionBodyDimensionsLogCreatePayload,
	IActionBodyDimensionsLogCreatePayloadDone,
	IActionBodyDimensionsLogCreatePayloadError,
} from './types';

export const bodyDimensionsLogCreate = actionCreatorAsync<
	IActionBodyDimensionsLogCreatePayload,
	IActionBodyDimensionsLogCreatePayloadDone,
	IActionBodyDimensionsLogCreatePayloadError
>(
	'bodyDimensionsLogCreate',
	async (params) => {
		const { bodyDimensionsLog } = params;
		const { data } = await Api.bodyDimensionsLog.create({
			body: bodyDimensionsLog,
		});

		return data;
	},
);
